import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  DBBranchList: {},
  DBKern: {},
  DBKernObj: {},
  SUBKONTE: {},
  menus: [
    {
      Cd: "A",
      Name1: "",
      options: [
        {
          Cd: "1",
          Name1: "",
          options: [],
        },
      ],
    },
  ],
  routes: [
    {
      Cd: "1",
      Name1: "/",
      Appr: "",
      WebRoute: "/",
    },
  ],
  roundingDigit: 2,
  Division: [],
  Location: {
    LocWithoutRights: [],
    LocWithRights: [],
  },
  DbData: {
    Branch: {},
    WMSPDTUserList: {},
  },
  LPO_GROUP: [],
  Apps: [],
  Currency:[]
};

const SliceDB = createSlice({
  name: "SliceDB",
  initialState: { value: initialState },

  reducers: {
    DB_BranchList_Set: (state, action) => {
      state.value.DBBranchList = action.payload;
    },
    DB_Kern_Set: (state, action) => {
      state.value.DBKern = action.payload;
    },
    DB_Kern_DBKernObj_Set: (state, action) => {
      state.value.DBKernObj = action.payload;
    },
    DB_menus_Set: (state, action) => {
      state.value.menus = action.payload;
    },
    DB_routes_Set: (state, action) => {
      state.value.routes = action.payload;
    },
    DB_RoundingDigit_Set: (state, action) => {
      state.value.roundingDigit = action.payload;
    },
    SUBKONTE: (state, action) => {
      state.value.SUBKONTE = action.payload;
    },
    Division_Set: (state, action) => {
      state.value.Division = action.payload;
    },
    Location_Set: (state, action) => {
      state.value.Location = action.payload;
    },
    DB_Data_Set: (state, action) => {
      state.value.DbData = action.payload;
    },

    DB_Init: (state) => {
      state.value = initialState;
    },
    SET_LPO_GROUP: (state, action) => {
      state.value.LPO_GROUP = action.payload;
    },
    SET_APPS: (state, action) => {
      state.value.Apps = action.payload;
    },
    SET_Currency: (state, action) => {
      state.value.Currency = action.payload;
    },
    // GrnTax_SetValue: (state, action) => {
    //   state.value = action.payload;
    // },
  },
});

export const {
  DB_BranchList_Set,
  DB_Kern_Set,
  DB_Init,
  DB_menus_Set,
  DB_routes_Set,
  DB_RoundingDigit_Set,
  SUBKONTE,
  Division_Set,
  Location_Set,
  DB_Data_Set,
  DB_Kern_DBKernObj_Set,
  SET_LPO_GROUP,
  SET_APPS,
  SET_Currency
} = SliceDB.actions;
export default SliceDB.reducer;
